<template>
    <link-lov-select :prefixIcon="!!searchIcon?'link-icon-search':null"
                     :lovType="dynamicFilter.lov"
                     :excludeLov="dynamicFilter.column.externalData.excludeLov"
                     disabledAutoSetDefault
                     @change="confirm"
                     ref="lov"
                     :value="dynamicFilter.value.val"/>
</template>

<script>
    import {DynamicFilterMixin} from "../link-dynamic-filter";

    export default {
        name: "link-dynamic-filter-lov",
        mixins: [DynamicFilterMixin],
        methods: {
            getValue() {
                this.dynamicFilter.value = {val: this.$refs.lov.model.value}
            },
        }
    }
</script>

<style lang="scss">

</style>